{
  "name": "material-dashboard-pro-angular",
  "version": "6.0.0",
  "license": "https://demos.creative-tim.com/material-dashboard-pro-angular2/documentation/tutorial",
  "repository": {
    "type": "git",
    "url": "https://github.com/creativetimofficial/ct-material-dashboard-pro-angular.git"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "playwright test --config=e2e/playwright.config.ts",
    "e2e:ui": "playwright test --config=e2e/playwright.config.ts --ui",
    "e2e:debug": "playwright test --config=e2e/playwright.config.ts --debug",
    "e2e:videos:mp4": "bash e2e/scripts/videos-to-mp4.sh",
    "install:clean": "rm -rf node_modules/ && rm -rf package-lock.json && npm install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.1",
    "@angular/cdk": "20.2.4",
    "@angular/common": "20.3.1",
    "@angular/compiler": "20.3.1",
    "@angular/core": "20.3.1",
    "@angular/forms": "20.3.1",
    "@angular/material": "20.2.4",
    "@angular/material-moment-adapter": "20.2.4",
    "@angular/platform-browser": "20.3.1",
    "@angular/platform-browser-dynamic": "20.3.1",
    "@angular/platform-server": "20.3.1",
    "@angular/router": "20.3.1",
    "@popperjs/core": "^2.11.8",
    "ajv": "6.12.5",
    "angular-calendar": "0.28.20",
    "angular-cc-library": "3.4.x",
    "angular-route": "^1.8.3",
    "animate.css": "4.1.1",
    "arrive": "^2.5.2",
    "bootstrap": "^5.3.7",
    "bootstrap-material-design": "^4.1.3",
    "bootstrap-notify": "^3.1.3",
    "bootstrap-rtl": "^3.3.4",
    "bootstrap-select": "^1.13.18",
    "core-js": "^3.44.0",
    "datatables": "1.10.18",
    "datatables.net-bs4": "1.13.11",
    "datatables.net-responsive": "2.2.6",
    "fullcalendar": "3.10.1",
    "googleapis": "61.0.0",
    "hammerjs": "2.0.8",
    "html2canvas-pro": "^2.4.3",
    "jasny-bootstrap": "4.0.0",
    "jquery": "^3.7.1",
    "jquery-validation": "^1.21.0",
    "jqvmap": "^1.5.1",
    "jwt-decode": "^3.1.2",
    "moment": "^2.29.1",
    "moment-timezone": "^0.6.0",
    "ng2-nouislider": "^2.0.0",
    "ng2-select": "2.0.0",
    "ngx-chips": "^3.0.0",
    "ngx-mercadopago": "^0.0.6",
    "ngx-paypal": "^11.0.0",
    "nouislider": "^15.8.1",
    "perfect-scrollbar": "^1.5.6",
    "popper.js": "1.16.1",
    "rxjs": "^7.8.2",
    "rxjs-compat": "^6.6.7",
    "scriptjs": "^2.5.9",
    "sweetalert2": "10.3.5",
    "twitter-bootstrap-wizard": "1.2.0",
    "uglify-js": "^3.19.3",
    "validate": "^5.2.0",
    "web-animations-js": "^2.3.2",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.2",
    "@angular/cli": "20.3.2",
    "@angular/compiler-cli": "20.3.1",
    "@playwright/test": "^1.61.1",
    "@types/bootstrap": "^5.2.10",
    "@types/jasmine": "~3.6.0",
    "@types/jquery": "^3.5.32",
    "@types/node": "14.11.5",
    "codelyzer": "^0.0.28",
    "dotenv": "^17.4.2",
    "jasmine-core": "~3.6.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "2.0.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "4.0.2",
    "karma-jasmine-html-reporter": "1.7.0",
    "sass-migrator": "^2.3.3",
    "ts-node": "9.0.0",
    "tslint": "6.1.3",
    "typescript": "5.8.3"
  }
}
